import { MasterDialog } from "#common/Dialog/Dialog"
import { UseContextsCategory } from "#competence/contexts/ContextsCategory"
import { CategoryIdGet } from "#competence/services/Api"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import CancelIcon from "@mui/icons-material/Cancel"
import EditIcon from "@mui/icons-material/Edit"
import { Box, Button, Divider, Skeleton, Stack, Typography } from "@mui/material"
import { Fragment, useEffect, useMemo, useState } from "react"
import ByAtInfo from "../ByAtInfo"
import ChipStatus from "../ChipStatus"

export default function CategoryInfo() {
	const {
		reload,
		category: categorySelected,
		setOpenForm,
		setCategory,
		setOpenDelete,
	} = UseContextsCategory()

	const params = useMemo(() => ({ id: categorySelected?.id }), [categorySelected?.id])
	const [open, setOpen] = useState(false)

	const {
		data: category,
		loading,
		error,
	} = useApi(CategoryIdGet, { autoFetch: !!params.id, params, reload })

	useEffect(() => {
		if (category?.id) setCategory(category)
	}, [category, setCategory])

	if (loading) return <Skeleton variant="rectangular" height={100} />
	if (error) return <ErrorResponse />

	return (
		<Fragment>
			<Stack direction={"column"} spacing={2} alignContent={"center"}>
				<Box>
					<Typography
						variant="h6"
						component="h3"
						gutterBottom
						fontWeight="600"
						color="text.primary"
					>
						{category.name}
					</Typography>
					<Stack
						spacing={1}
						direction={"row"}
						alignItems={"center"}
						justifyContent={"space-between"}
					>
						<Stack direction={"row"} spacing={1}>
							<ChipStatus active={category.active} />
						</Stack>
					</Stack>
				</Box>
				<Divider />
				<Box>
					<Typography
						variant="h6"
						component="h3"
						gutterBottom
						fontWeight="600"
						color="text.primary"
					>
						Description
					</Typography>
					<Typography
						variant="body2"
						textAlign="left"
						color="text.secondary"
						whiteSpace="pre-line"
						sx={{}}
					>
						{category.description}
					</Typography>
				</Box>
				<ByAtInfo
					title={"Creado por"}
					at={category.created_at}
					name={category.created_by_name}
				/>
				<ByAtInfo
					title={"Editado por"}
					at={category.updated_at}
					name={category.updated_by_name}
				/>
				{category.active && (
					<Fragment>
						<Divider />
						<Stack
							direction={"row"}
							spacing={3}
							alignItems={"center"}
							alignContent={"center"}
							justifyContent={"center"}
						>
							<Button
								startIcon={<EditIcon />}
								onClick={() => {
									setOpenForm(true)
								}}
							>
								Editar
							</Button>
							<Button
								startIcon={<CancelIcon />}
								onClick={() => {
									setOpenDelete(true)
								}}
								color="error"
							>
								Desactivar
							</Button>
						</Stack>
					</Fragment>
				)}
			</Stack>
		</Fragment>
	)
}

export const CategoryInfoDialog = () => {
	const { setOpenInfo: setOpen, openInfo: open, setCategory } = UseContextsCategory()

	return (
		<MasterDialog
			{...{ open, setOpen, maxWidth: "sm", closeDialog: () => setCategory(null) }}
		>
			<CategoryInfo />
		</MasterDialog>
	)
}
